export const twtLicenseMappingCheck = (peopleInformation: any, twtLicenseMapper: any) => {
  let productsArr = twtLicenseMapper.filter((product: any) => {
    let foundObj = peopleInformation.find((obj: any) => obj.productId === product.productId);
    if(foundObj) {
      return foundObj;
    }
  });
  return (sessionStorage.getItem("isDemoUser") || productsArr.length === 0) ?  [{ productId: "20", language: "EN" }] : productsArr;
}